import React, { Component } from 'react'
import PopUp from '../round/PopUp'
import BoundCoach from '../exam/BoundCoach'
import Triangle from '../round/Triangle'
import './game.css'
import '../round/round.css'
import { get, post } from '../../ajax/tools'
import CheckboxIcoNot from '../../style/image/CheckboxIcoNot.png'
import CheckboxIcoHave from '../../style/image/CheckboxIcoHave.png'

class GGAddPopEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      IdNum: '', //用户id号
      BoundCoachId: '', //绑定教练员（辅导员）的ID
      BoundCoachIdNum: '', //绑定教练员（辅导员）的ID号

      IdtArr: [
        { id: 2, idt: '运动员' },
        { id: 3, idt: '教练员（辅导员）' },
        { id: 4, idt: '领队' },
      ], //身份
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      IdtShow: '',
      IdtShowId: '',
      GroupArr: [], //组别
      GroupInfo: {}, //已选择组别信息
      GroupIsToggleOn: true,
      GroupBtn: 'false',
      GroupShow: '',
      ProjectArr: [], //项目总数据
      ProjectBrr: [], //已经选择的项目
      ProjectBrrNum: 0,
      ProjectMaxNum: null, //最多兼项数目

      UserEditInfo: {},
      UserEditInfoOther: {},
      UserImage: '',
      UserRealName: '',
      UserYYNum: '',
      SchoolId: '',
      UserId: '',
      BgMainHeight: document.documentElement.scrollTop,
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const history = nextProps
    let UserEditInfo = history.UserEditInfo
    for (let i = 0; i < UserEditInfo.item.length; i++) {
      UserEditInfo.item[i]['Num'] = i + 1
    }
    this.setState({
      UserImage: UserEditInfo.image,
      UserRealName: UserEditInfo.real_name,
      UserYYNum: UserEditInfo.yy_num,
      SchoolId: UserEditInfo.school_id,
      UserId: UserEditInfo.user_id,
      IdtShow: UserEditInfo.IdtShow,
      IdtShowId: UserEditInfo.identity,
      GroupShow: UserEditInfo.groups,
      GroupId: UserEditInfo.group_id,
      ProjectBrr: UserEditInfo.item,
      ProjectBrrNum: UserEditInfo.item.length,
      BoundCoachIdNum: UserEditInfo.coach_yy_num,
      BoundCoachId: UserEditInfo.coach_id,
      MatchId: history.MatchId,
      GGWindowId: history.GGWindowId,
      UserEditInfoOther: UserEditInfo,
    })
  }

  componentDidMount = function () {
    const history = this.props
    let UserEditInfo = history.UserEditInfo
    let MatchId = history.MatchId
    for (let i = 0; i < UserEditInfo.item.length; i++) {
      UserEditInfo.item[i]['Num'] = i + 1
    }
    //console.log(UserEditInfo)
    this.setState({
      UserImage: UserEditInfo.image,
      UserRealName: UserEditInfo.real_name,
      UserYYNum: UserEditInfo.yy_num,
      SchoolId: UserEditInfo.school_id,
      UserId: UserEditInfo.user_id,
      IdtShow: UserEditInfo.IdtShow,
      IdtShowId: UserEditInfo.identity,
      GroupShow: UserEditInfo.groups,
      GroupId: UserEditInfo.group_id,
      ProjectBrr: UserEditInfo.item,
      ProjectBrrNum: UserEditInfo.item.length,
      BoundCoachIdNum: UserEditInfo.coach_yy_num,
      BoundCoachId: UserEditInfo.coach_id,
      MatchId: MatchId,
      GGWindowId: history.GGWindowId,
      UserEditInfoOther: UserEditInfo,
    })
    get({ url: 'match/get_groups/' + MatchId }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          GroupArr: res.data,
        })
        let magId = []
        for (let k = 0; k < res.data.length; k++) {
          if (res.data[k].group_id === UserEditInfo.group_id) {
            let a = {}
            a['mag_id'] = res.data[k].mag_id
            magId.push(a)
          }
        }
        if (magId.length !== 0) {
          post({
            url: 'match/get_item',
            data: {
              match_id: MatchId,
              mag_id: magId[0].mag_id,
            },
          }).then((res) => {
            if (res.errno === '200') {
              let ProjectTheArr = res.data
              for (let k = 0; k < ProjectTheArr.length; k++) {
                ProjectTheArr[k]['mag_id'] = magId[0].mag_id
                ProjectTheArr[k]['MixingName'] =
                  ProjectTheArr[k].name + '(' + UserEditInfo.groups + ')'
              }
              this.setState({
                ProjectArr: ProjectTheArr,
                ProjectMaxNum: res.allow_item_num,
              })
            }
          })
        }
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.errmsg + '！',
        })
      }
    })
    document.onclick = this.AllClick.bind(this) //下拉菜单监听隐藏
  }

  AllClick = () => {
    this.setState({
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      GroupIsToggleOn: true,
      GroupBtn: 'false',
    })
  }

  componentWillUnmount = () => {
    this.setState = () => {}
  }

  //下拉菜单按钮
  ClickIdtDb(e) {
    e.nativeEvent.stopImmediatePropagation()
    this.setState((prevState) => ({
      IdtIsToggleOn: !prevState.IdtIsToggleOn,
      IdtBtn: prevState.IdtIsToggleOn ? 'true' : 'false',
      GroupIsToggleOn: true,
      GroupBtn: 'false',
    }))
  }
  ClickGroupDb(e) {
    e.nativeEvent.stopImmediatePropagation()
    this.setState((prevState) => ({
      GroupIsToggleOn: !prevState.GroupIsToggleOn,
      GroupBtn: prevState.GroupIsToggleOn ? 'true' : 'false',
      IdtIsToggleOn: true,
      IdtBtn: 'false',
    }))
  }

  //点击选择下拉菜单的内容
  ClickIdtArr = (item, index) => {
    this.setState({
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      IdtShow: item.idt,
      IdtShowId: item.id,
      ProjectBrr: [],
      ProjectBrrNum: 0,
      GroupShow: '',
      BoundCoachIdNum: '',
    })
  }
  ClickGroupArr = (item, index) => {
    // 年龄提示
    post({
      url: 'match/group_age_remind',
      data: {
        match_id: this.state.MatchId,
        group_id: item.group_id,
        user_id: this.state.UserId,
      },
    }).then((res) => {
      if (res.errno === '4105') {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.errmsg + '！',
        })
      }
    })
    this.setState({
      GroupIndex: index,
      GroupIsToggleOn: true,
      GroupBtn: 'false',
      GroupShow: item.name,
      GroupInfo: item,
      ProjectBrr: [],
      ProjectBrrNum: 0,
    })
    let MatchId = this.state.MatchId
    post({
      url: 'match/get_item',
      data: {
        match_id: MatchId,
        mag_id: item.mag_id,
      },
    }).then((res) => {
      if (res.errno === '200') {
        let ProjectTheArr = res.data
        for (let k = 0; k < ProjectTheArr.length; k++) {
          ProjectTheArr[k]['mag_id'] = item.mag_id
          ProjectTheArr[k]['MixingName'] =
            ProjectTheArr[k].name + '(' + item.name + ')'
        }
        this.setState({
          ProjectArr: ProjectTheArr,
          ProjectMaxNum: res.allow_item_num,
        })
      }
    })
  }
  //点击选择/取消选择项目
  ClickProjectArr = (item, index) => {
    let ProjectBrr = [...this.state.ProjectBrr]
    let ProjectMaxNum = this.state.ProjectMaxNum
    const existIndex = ProjectBrr.findIndex((p) => p.item_name === item.name)

    // 已选中则取消选择
    if (existIndex !== -1) {
      ProjectBrr.splice(existIndex, 1)
      ProjectBrr.forEach((p, i) => {
        p.Num = i + 1
      })
      this.setState({
        ProjectIndex: index,
        ProjectBrr: ProjectBrr,
        ProjectBrrNum: ProjectBrr.length,
      })
      return
    }

    let ProjectTrr = ProjectBrr.filter((p) => p.is_concurrent === 1)
    if (ProjectBrr.length === 0) {
      ProjectBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: item.mag_id,
        mai_id: item.id,
        Num: 1,
        is_concurrent: item.is_concurrent,
      })
    } else if (ProjectTrr.length < ProjectMaxNum || item.is_concurrent !== 1) {
      ProjectBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: item.mag_id,
        mai_id: item.id,
        Num: ProjectBrr.length + 1,
        is_concurrent: item.is_concurrent,
      })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '计入兼项科目数量已达到最多兼项限制',
      })
      return
    }
    this.setState({
      ProjectIndex: index,
      ProjectBrr: ProjectBrr,
      ProjectBrrNum: ProjectBrr.length,
    })
  }

  //按兼项限制计算可全选的项目列表
  getSelectableProjects = () => {
    const { ProjectArr, ProjectMaxNum } = this.state
    let newBrr = []
    let concurrentCount = 0
    let limited = false
    for (let i = 0; i < ProjectArr.length; i++) {
      const item = ProjectArr[i]
      if (item.is_concurrent === 1) {
        if (ProjectMaxNum != null && concurrentCount >= ProjectMaxNum) {
          limited = true
          continue
        }
        concurrentCount++
      }
      newBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: item.mag_id,
        mai_id: item.id,
        Num: newBrr.length + 1,
        is_concurrent: item.is_concurrent,
      })
    }
    return { list: newBrr, limited }
  }

  //是否已选满当前可全选项目
  isAllSelectableSelected = () => {
    const { list } = this.getSelectableProjects()
    const { ProjectBrr } = this.state
    if (list.length === 0 || ProjectBrr.length !== list.length) {
      return false
    }
    return list.every((item) =>
      ProjectBrr.some((p) => p.item_name === item.item_name)
    )
  }

  //全选 / 取消全选项目
  ClickProjectSelectAll = () => {
    const { ProjectArr } = this.state
    if (!ProjectArr || ProjectArr.length === 0) {
      return
    }

    if (this.isAllSelectableSelected()) {
      this.setState({
        ProjectBrr: [],
        ProjectBrrNum: 0,
      })
      return
    }

    const { list, limited } = this.getSelectableProjects()
    this.setState({
      ProjectBrr: list,
      ProjectBrrNum: list.length,
      ...(limited
        ? {
            PopUp: '提示弹窗',
            MessageTip: '计入兼项科目数量已达到最多兼项限制，部分项目未能全选',
          }
        : {}),
    })
  }

  isProjectSelected = (item) => {
    return this.state.ProjectBrr.some((p) => p.item_name === item.name)
  }

  //绑定教练员（辅导员）的返回逻辑处理
  BoundCoachBack(event) {
    this.setState({
      BoundCoachId: event.CoachId,
      BoundCoachIdNum: event.CoachIdNum,
    })
  }

  GGAddPopEditBtnOK() {
    let IdtShow = this.state.IdtShow
    let IdtShowId = this.state.IdtShowId
    let GroupShow = this.state.GroupShow
    let GroupInfo = this.state.GroupInfo
    let ProjectBrr = this.state.ProjectBrr
    let BoundCoachId = this.state.BoundCoachId
    let BoundCoachIdNum = this.state.BoundCoachIdNum
    let MatchId = this.state.MatchId
    let ProjectMaxNum = this.state.ProjectMaxNum
    let SchoolId = this.state.SchoolId
    let UserId = this.state.UserId
    let GGWindowId = this.state.GGWindowId
    let UserEditInfoOther = this.state.UserEditInfoOther
    if (IdtShow !== '' && IdtShow === '运动员') {
      if (
        GroupShow !== '' &&
        ProjectBrr.length !== 0 &&
        BoundCoachIdNum !== ''
      ) {
        let UserEditInfo = this.state.UserEditInfo
        UserEditInfo['province'] = ''
        UserEditInfo['allow_item_num'] = ProjectMaxNum
        UserEditInfo['match_id'] = MatchId
        UserEditInfo['IdtShow'] = IdtShow
        UserEditInfo['identity'] = IdtShowId
        UserEditInfo['groups'] = GroupShow
        UserEditInfo['group_id'] = GroupInfo.group_id
          ? GroupInfo.group_id
          : UserEditInfoOther.group_id
        UserEditInfo['item'] = ProjectBrr
        UserEditInfo['coach_id'] = BoundCoachId
        UserEditInfo['coach_yy_num'] = BoundCoachIdNum
        UserEditInfo['team_id'] = GGWindowId
        UserEditInfo['user_id'] = UserId
        UserEditInfo['school_id'] = SchoolId
        get({ url: 'user/basic_info' }).then((res) => {
          if (res.errno === '200') {
            let User = res.data[0]
            if (User.type === 1) {
              post({
                url: 'match/update_match_enroll_team',
                data: UserEditInfo,
              }).then((res) => {
                if (res.errno === '200') {
                  let newObj = {}
                  Object.assign(newObj, UserEditInfoOther, UserEditInfo)
                  let ClickInfo = { BackType: 'OK', UserEditInfo: newObj }
                  this.props.GGAddPopEdit(ClickInfo)
                } else if (res.errno === '201') {
                  let newObj = {}
                  Object.assign(newObj, UserEditInfoOther, UserEditInfo)
                  let ClickInfo = { BackType: 'OK', UserEditInfo: newObj }
                  this.props.GGAddPopEdit(ClickInfo)
                } else {
                  this.setState({
                    PopUp: '提示弹窗',
                    MessageTip: res.errmsg + '！',
                  })
                }
              })
            } else if (User.type === 0) {
              this.setState({
                PopUp: '账号被顶',
                MessageTip: '当前设备已登录其他账户，请重新登录！',
              })
            }
          } else {
            sessionStorage.setItem('routesAddress', '/match')
            const { history } = this.props
            history.push('/login')
          }
        })
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: '您有必要的选项未选择！',
        })
      }
    } else if (IdtShow !== '' && IdtShow !== '运动员') {
      let UserEditInfo = this.state.UserEditInfo
      UserEditInfo['province'] = ''
      UserEditInfo['allow_item_num'] = ProjectMaxNum
      UserEditInfo['match_id'] = MatchId
      UserEditInfo['IdtShow'] = IdtShow
      UserEditInfo['identity'] = IdtShowId
      UserEditInfo['groups'] = GroupShow
      UserEditInfo['group_id'] = ''
      UserEditInfo['item'] = ProjectBrr
      UserEditInfo['coach_id'] = BoundCoachId
      UserEditInfo['coach_yy_num'] = BoundCoachIdNum
      UserEditInfo['team_id'] = GGWindowId
      UserEditInfo['user_id'] = UserId
      UserEditInfo['school_id'] = SchoolId
      get({ url: 'user/basic_info' }).then((res) => {
        if (res.errno === '200') {
          let User = res.data[0]
          if (User.type === 1) {
            post({
              url: 'match/update_match_enroll_team',
              data: UserEditInfo,
            }).then((res) => {
              if (res.errno === '200') {
                let newObj = {}
                Object.assign(newObj, UserEditInfoOther, UserEditInfo)
                let ClickInfo = { BackType: 'OK', UserEditInfo: newObj }
                this.props.GGAddPopEdit(ClickInfo)
              } else if (res.errno === '201') {
                let newObj = {}
                Object.assign(newObj, UserEditInfoOther, UserEditInfo)
                let ClickInfo = { BackType: 'OK', UserEditInfo: newObj }
                this.props.GGAddPopEdit(ClickInfo)
              } else {
                this.setState({
                  PopUp: '提示弹窗',
                  MessageTip: res.errmsg + '！',
                })
              }
            })
          } else if (User.type === 0) {
            this.setState({
              PopUp: '账号被顶',
              MessageTip: '当前设备已登录其他账户，请重新登录！',
            })
          }
        } else {
          sessionStorage.setItem('routesAddress', '/match')
          const { history } = this.props
          history.push('/login')
        }
      })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '您有必要的选项未选择！',
      })
    }
  }

  GGAddPopEditBtnERR() {
    let ClickInfo = { BackType: 'ERR' }
    this.props.GGAddPopEdit(ClickInfo)
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }
  AccountNext = (event) => {
    if (event === 'CrossOut') {
      window.location.reload()
    } else if (event === 'Confirm') {
      window.location.reload()
    }
  }

  render() {
    return (
      <div>
        <div className={'PopUpBoxBg'}> </div>
        <div
          className={'GGAddPopUpBgBox'}
          style={{ top: this.state.BgMainHeight + 2 }}
        >
          <div className={'GGAddPopBorder'} style={{ marginTop: 60 }}>
            <div className={'GGAddPopTitleBox'} style={{ marginTop: 6 }}>
              重新编辑人员信息
            </div>
            <div
              className={'GGAddPopMainBox clearfix'}
              style={{ marginTop: 2, marginBottom: 5 }}
            >
              <div className={'GGAPInfoBox'}>
                <div className={'GGAPInfoPhoto'}>
                  <img alt={''} src={this.state.UserImage} />
                </div>
                <div className={'GGAPInfoListBox clearfix'}>
                  <div className={'GGAPInfoListTit'}>姓名：</div>
                  <div className={'GGAPInfoListCon'}>
                    {this.state.UserRealName}
                  </div>
                </div>
                <div className={'GGAPInfoListBox clearfix'}>
                  <div className={'GGAPInfoListTit'}>ID：</div>
                  <div className={'GGAPInfoListCon'}>
                    {this.state.UserYYNum}
                  </div>
                </div>
              </div>
              <div className={'GGAPSelectBox'}>
                <ul
                  className={'GPClickUlBox clearfix'}
                  style={{ marginTop: 40 }}
                >
                  <li className={'GPClickLiBox'}>
                    <div className={'GPClickInfoTit'}>*参赛身份</div>
                    <div className={'GPClickInfoCon'}>
                      <div
                        className={'GPDownBtn'}
                        onClick={this.ClickIdtDb.bind(this)}
                      >
                        <Triangle
                          Direction={'down'}
                          Color={'#FFFFFF'}
                          Width={'7px'}
                          Height={'10px'}
                          Top={'10px'}
                          Right={'23px'}
                        />
                      </div>
                      <div className={'GPSelectShow'}>
                        {this.state.IdtShow === ''
                          ? '请选择参赛身份'
                          : this.state.IdtShow}
                      </div>
                      {this.state.IdtBtn === 'true' && (
                        <div className={'GPSelect'}>
                          {this.state.IdtArr.map((item, index) => (
                            <div
                              className={'GPOption'}
                              key={index}
                              onClick={() => this.ClickIdtArr(item, index)}
                            >
                              {item.idt}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>
                  {this.state.IdtShow === '教练员（辅导员）' ||
                    this.state.IdtShow === '领队' || (
                      <div>
                        <li className={'GPClickLiBox'}>
                          <div className={'GPClickInfoTit'}>*参赛组别</div>
                          <div className={'GPClickInfoCon'}>
                            <div
                              className={'GPDownBtn'}
                              onClick={this.ClickGroupDb.bind(this)}
                            >
                              <Triangle
                                Direction={'down'}
                                Color={'#FFFFFF'}
                                Width={'7px'}
                                Height={'10px'}
                                Top={'10px'}
                                Right={'23px'}
                              />
                            </div>
                            <div className={'GPSelectShow'}>
                              {this.state.GroupShow === ''
                                ? '请选择参赛组别'
                                : this.state.GroupShow}
                            </div>
                            {this.state.GroupBtn === 'true' && (
                              <div className={'GPSelect'}>
                                {this.state.GroupArr.map((item, index) => (
                                  <div
                                    className={'GPOption'}
                                    key={index}
                                    onClick={() =>
                                      this.ClickGroupArr(item, index)
                                    }
                                  >
                                    {item.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </li>
                        <li className={'GPClickLiBox clearfix'}>
                          <div className={'GPClickInfoTit'}>*参赛项目</div>
                          <div className={'GPClickInfoCon'}>
                            <div className={'GPProjectListBox'}>
                              <div className={'GPProjectListHeader'}>
                                <div
                                  className={'GPProjectSelectAllBtn'}
                                  onClick={this.ClickProjectSelectAll}
                                >
                                  {this.isAllSelectableSelected()
                                    ? '取消全选'
                                    : '全选'}
                                </div>
                                <div className={'GPProjectSelectedCount'}>
                                  已选择{this.state.ProjectBrrNum}项目
                                </div>
                              </div>
                              <div className={'GPProjectListScroll'}>
                                {this.state.ProjectArr.length === 0 ? (
                                  <div className={'GPProjectListEmpty'}>
                                    请先选择参赛组别
                                  </div>
                                ) : (
                                  this.state.ProjectArr.map((item, index) => {
                                    const selected =
                                      this.isProjectSelected(item)
                                    return (
                                      <div
                                        className={
                                          'GPProjectListItem' +
                                          (selected ? ' selected' : '')
                                        }
                                        key={index}
                                        title={item.name}
                                        onClick={() =>
                                          this.ClickProjectArr(item, index)
                                        }
                                      >
                                        <span
                                          className={'GPProjectListCheckbox'}
                                          style={{
                                            backgroundImage: selected
                                              ? 'url(' + CheckboxIcoHave + ')'
                                              : 'url(' + CheckboxIcoNot + ')',
                                          }}
                                        />
                                        <span className={'GPProjectListName'}>
                                          {item.name}
                                        </span>
                                      </div>
                                    )
                                  })
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    )}
                </ul>
                {this.state.IdtShow === '运动员' && (
                  <BoundCoach
                    BoundCoachBack={this.BoundCoachBack.bind(this)}
                    IdNum={this.state.IdNum}
                    BoundCoachIdNum={this.state.BoundCoachIdNum}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={'GGAddPopUpBtnBox clearfix'}>
            <div
              className={'GGAddPopUpBtnOK'}
              onClick={this.GGAddPopEditBtnOK.bind(this)}
            >
              确定
            </div>
            <div
              className={'GGAddPopUpBtnERR'}
              onClick={this.GGAddPopEditBtnERR.bind(this)}
            >
              取消
            </div>
          </div>
        </div>
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
        {this.state.PopUp === '账号被顶' && (
          <PopUp
            ChildBackClick={this.AccountNext.bind(this)}
            type={'失败'}
            message={this.state.MessageTip}
            OutButton={'No'}
          />
        )}
      </div>
    )
  }
}

export default GGAddPopEdit
